module.exports = __webpack_public_path__ + "static/media/left-arrow.3b99260b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/left-arrow.svg
// module id = 102
// module chunks = 0